






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { Case } from '@/modules/Case/interfaces/case'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'

@Component({
  components: {
    AppSystemInfoCard
  }
})
export default class CaseDetailAdditional extends Vue {
  @Prop({ type: Object as () => Case }) readonly caseInfo!: Case
}
